export default "__VITE_ASSET__Cl_1Khb1__"